import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-image-options',
  templateUrl: './image-options.component.html',
  standalone: false,
})
export class ImageOptionsComponent {
  @Input() parentForm!: FormGroup;
}
